<template>
  <main class="resume-print-layout">
    <slot />
  </main>
</template>

<style scoped>
html,
:root {
  --ui-bg: var(--color-white);
}
.resume-print-layout {
  position: relative;
  min-height: 100vh;
  padding: 2rem 1.25rem;
}

@media screen {
  .resume-print-layout {
    max-width: 210mm;
    margin: 0 auto;
  }
}

@media print {
  :global(body) {
    margin: 0;
    /* 
    background: #ffffff;
    color: #000000; 
    */
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  :global(*),
  :global(*::before),
  :global(*::after) {
    border-style: none !important;
    border-width: 0 !important;
    outline: 0 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }

  :global(body),
  :global(#__nuxt),
  .resume-print-layout {
    border: 0 !important;
    border-style: none !important;
  }

  .resume-print-layout {
    max-width: none;
    padding: 0;
  }
}
</style>
